import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../../css/Manage.css";
import "../../css/space/ManageSpaceAdit.css";
import SpaceApi from "../../api/spaceApi";
import { toast } from "react-toastify";
import { Map, MapMarker } from "react-kakao-maps-sdk";

const ManageSpaceAdit = () => {
  let navigate = useNavigate();
  let location = useLocation();

  const [delId, setDelId] = useState([]);
  const [duplCheck, setDuplCheck] = useState(true);
  const [spaceId, setSpaceId] = useState(null);
  const [spaceFile, setSpaceFile] = useState([]);
  const [spaceInfo, setSpaceInfo] = useState({});
  const subMenuCatagory = [
    { spaceCategory: "CAFE", spaceCategoryTitle: "카페·제과" },
    { spaceCategory: "RESTAURANT", spaceCategoryTitle: "맛집" },
    { spaceCategory: "PUB", spaceCategoryTitle: "술집" },
    { spaceCategory: "TOUR", spaceCategoryTitle: "관광지" },
    { spaceCategory: "LIFE", spaceCategoryTitle: "생활" },
    { spaceCategory: "EXPERIENCE", spaceCategoryTitle: "체험" },
    { spaceCategory: "SHOP", spaceCategoryTitle: "가게" },
    { spaceCategory: "ETC", spaceCategoryTitle: "기타" },
  ];
  const [selectMenu, setSelectMenu] = useState(false);
  const [selectMenuText, setSelectMenuText] =
    useState("공간 카테고리를 선택하세요");

  useEffect(() => {
    if (location.state) {
      const { id } = location.state;
      setSpaceId(location.state.id);
      getSpaceInfo(id);
    }
  }, [location]);

  const getSpaceInfo = async (id) => {
    try {
      const info = (await SpaceApi.GetSpace(id)).data.data.content;
      setSpaceInfo((spaceInfo) => ({
        ...spaceInfo,
        ...info,
        accountDeleteFlag: false,
        idCardDeleteFlag: false,
        profileDeleteFlag: false,
        backgroundDeleteFlag: false,
        imageDeleteFlag: false,
        imagesFlag: false,
        imagesDeleteIds: [],
      }));
      setSpaceFile(info.spaceFiles);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setSpaceInfo((spaceInfo) => ({
      ...spaceInfo,
      spaceFiles: spaceFile,
      imagesDeleteIds: delId,
    }));
  }, [spaceFile]);

  const spaceImg = (e, type, url, flag) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      setSpaceInfo((spaceInfo) => ({
        ...spaceInfo,
        [type]: file,
        [url]: e.target.result,
        [flag]: true,
      }));
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const spaceImgs = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const arr = [...spaceFile];
      const obj = {};
      obj.image = file;
      obj.imageUrl = e.target.result;
      arr.push(obj);
      setSpaceFile(arr);
      setSpaceInfo((spaceInfo) => ({
        ...spaceInfo,
        imagesFlag: true,
      }));
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  const deleteImage = (type, url, flag) => {
    setSpaceInfo((spaceInfo) => ({
      ...spaceInfo,
      [type]: null,
      [url]: "",
      [flag]: true,
    }));
  };

  const deleteImages = (id, index) => {
    let copyDel = [...delId];
    let copyFile = [...spaceFile];
    copyFile.splice(index, 1);
    let copyData = [...spaceInfo.spaceFiles];
    copyData.splice(index, 1);
    setSpaceInfo((spaceInfo) => ({
      ...spaceInfo,
      spaceFiles: copyData,
      imagesDeleteIds: copyDel,
    }));
    setSpaceFile(copyFile);
  };

  // useEffect(() => {
  //   deleteImages(item.id, index);
  // }, [delId]);

  const spaceAdd = async () => {
    if (!duplCheck) {
      toast("공간명 중복을 확인해주세요");
    } else {
      try {
        const formData = new FormData();
        formData.append("name", spaceInfo.name);
        formData.append("managerName", spaceInfo.managerName);
        formData.append("phoneNumber", spaceInfo.phoneNumber);
        formData.append("email", spaceInfo.email);
        formData.append("companyName", spaceInfo.companyName);
        if (spaceInfo.accountDeleteFlag) {
          formData.append("account", spaceInfo.account);
        }
        if (spaceInfo.idCardDeleteFlag) {
          formData.append("idCard", spaceInfo.idCard);
        }
        if (spaceInfo.spaceCategory) {
          formData.append("spaceCategory", spaceInfo.spaceCategory);
        }
        if (spaceInfo.profileDeleteFlag) {
          formData.append("profile", spaceInfo.profile);
        }
        if (spaceInfo.backgroundDeleteFlag) {
          formData.append("background", spaceInfo.background);
        }
        formData.append("intro", spaceInfo.intro);
        if (spaceInfo.subCategory) {
          formData.append("subCategory", spaceInfo.subCategory);
        }
        formData.append("businessHours", spaceInfo.businessHours);
        formData.append("address", spaceInfo.address);
        if (spaceInfo.addressDetail) {
          formData.append("addressDetail", spaceInfo.addressDetail);
        }
        formData.append("lat", spaceInfo.lat);
        formData.append("lon", spaceInfo.lon);
        formData.append("tell", spaceInfo.tell);
        if (spaceInfo.imageDeleteFlag) {
          formData.append("image", spaceInfo.image);
        }
        if (spaceInfo.imagesFlag) {
          for (let i = 0; i < spaceInfo.spaceFiles.length; i++) {
            if (spaceInfo.spaceFiles[i].image) {
              formData.append(`images`, spaceInfo.spaceFiles[i].image);
            }
          }
        }
        formData.append("detail", spaceInfo.detail);
        formData.append("accountDeleteFlag", spaceInfo.accountDeleteFlag);
        formData.append("idCardDeleteFlag", spaceInfo.idCardDeleteFlag);
        formData.append("profileDeleteFlag", spaceInfo.profileDeleteFlag);
        formData.append("backgroundDeleteFlag", spaceInfo.backgroundDeleteFlag);
        formData.append("imageDeleteFlag", spaceInfo.imageDeleteFlag);

        if (spaceInfo.imagesDeleteIds.length) {
          for (let i = 0; i < spaceInfo.imagesDeleteIds.length; i++) {
            formData.append(`imagesDeleteIds`, spaceInfo.imagesDeleteIds[i]);
          }
        }

        await SpaceApi.Patch(spaceId, formData);
        toast("수정되었습니다.");
        navigate(`/admin/space/detail/${spaceId}`, { state: { id: spaceId } });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const execDaumPostcode = () => {
    let geocoder = new window.kakao.maps.services.Geocoder();
    new window.daum.Postcode({
      oncomplete: (data) => {
        if (data.userSelectedType === "R") {
          // 사용자가 도로명 주소를 선택했을 경우
          geocoder.addressSearch(
            `${data.roadAddress}`,
            function (result, status) {
              // 정상적으로 검색이 완료됐으면
              if (status === window.kakao.maps.services.Status.OK) {
                setSpaceInfo({
                  ...spaceInfo,
                  address: data.roadAddress,
                  lat: result[0].y,
                  lon: result[0].x,
                });
              }
            }
          );
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          geocoder.addressSearch(
            `${data.roadAddress}`,
            function (result, status) {
              // 정상적으로 검색이 완료됐으면
              if (status === window.kakao.maps.services.Status.OK) {
                setSpaceInfo({
                  ...spaceInfo,
                  address: data.jibunAddress,
                  lat: result[0].y,
                  lon: result[0].x,
                });
              }
            }
          );
        }
      },
    }).open();
  };

  const checkName = async () => {
    let obj = {
      name: spaceInfo.name,
    };
    try {
      await SpaceApi.GetCheck(obj);
      toast("확인되었습니다");
      setDuplCheck(true);
    } catch (error) {
      toast(error.response.data.message);
    }
  };

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-space-adit">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-space-adit">
          <span>수정하기</span>
          <div>
            <span>기본정보</span>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">등록관리자이메일</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="email"
                placeholder="이메일"
                disabled
                value={spaceInfo.manager ? spaceInfo.manager.email : null}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">공간명*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="text"
                placeholder="공간명을 입력하세요"
                required
                value={spaceInfo.name}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    name: e.target.value,
                  }));
                  setDuplCheck(false);
                }}
              />
              <a className="space-name-duplication-check" onClick={checkName}>
                공간명 중복 확인
              </a>
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">담당자명*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="text"
                placeholder="담당자명을 입력하세요"
                required
                value={spaceInfo.managerName}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    managerName: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">휴대전화*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="tel"
                placeholder="휴대전화번호를 입력하세요. (숫자만 입력가능)"
                required
                value={spaceInfo.phoneNumber}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    phoneNumber: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">이메일*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="email"
                placeholder="이메일을 입력하세요"
                required
                value={spaceInfo.email}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    email: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">상호(기업)명*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="text"
                placeholder="상호(기업)명을 입력하세요"
                required
                value={spaceInfo.companyName}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    companyName: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">통장사본</span>
              <div className="space-adit-input-file-container">
                <label htmlFor="account-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="account-file-input"
                  className="Manage-input-textarea manage-form-space-adit-input"
                  type="file"
                  required
                  onChange={(e) => {
                    spaceImg(e, "account", "accountUrl", "accountDeleteFlag");
                  }}
                />
                {spaceInfo.accountUrl ? (
                  <div className="space-img">
                    <img className="uploaded-img" src={spaceInfo?.accountUrl} />
                    <img
                      className="space-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) =>
                        deleteImage(
                          "account",
                          "accountUrl",
                          "accountDeleteFlag"
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Manage-input-container manage-flex-start input-container-last">
              <span className="Manage-input-title">
                신분증
                <br />
                (개인일 경우 등록)
              </span>
              <div className="space-adit-input-file-container">
                <label htmlFor="id-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="id-file-input"
                  className="Manage-input-textarea manage-form-space-adit-input"
                  type="file"
                  onChange={(e) => {
                    spaceImg(e, "idCard", "idCardUrl", "idCardDeleteFlag");
                  }}
                />
                {spaceInfo.idCardUrl ? (
                  <div className="space-img">
                    <img className="uploaded-img" src={spaceInfo?.idCardUrl} />
                    <img
                      className="space-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) =>
                        deleteImage("idCard", "idCardUrl", "idCardDeleteFlag")
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div>
            <span className="space-adit-title">프로필 관리</span>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <p className="Manage-input-title">카테고리*</p>
              <div className="select">
                <div
                  className="selected"
                  onClick={() => setSelectMenu(!selectMenu)}
                >
                  <div className="selected-value">
                    {spaceInfo.spaceCategoryTitle}
                  </div>
                  <div className="select-toggle-btn">
                    <img src="\img\table-togle.svg" />
                  </div>
                </div>
                {selectMenu ? (
                  <ul className="option-container">
                    {subMenuCatagory.map((item, index) => {
                      return (
                        <li
                          className="option"
                          onClick={() => {
                            setSpaceInfo((spaceInfo) => ({
                              ...spaceInfo,
                              spaceCategory: item.spaceCategory,
                              spaceCategoryTitle: item.spaceCategoryTitle,
                            }));
                            setSelectMenu(false);
                          }}
                        >
                          {item.spaceCategoryTitle}
                        </li>
                      );
                    })}
                  </ul>
                ) : null}
              </div>
            </div>
            <div className="Manage-input-container Manage-input-container-space-add">
              <span className="Manage-input-title">서브 카테고리</span>
              <input
                className="Manage-input-textarea manage-form-space-add-input"
                type="text"
                placeholder="ooo, ooo, ooo 형태로 입력하세요"
                value={spaceInfo.subCategory}
                onChange={(e) => {
                  setSpaceInfo({
                    ...spaceInfo,
                    subCategory: e.target.value,
                  });
                }}
              />
            </div>
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">프로필 이미지*</span>
              <div className="space-adit-input-file-container">
                <label htmlFor="profile-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="profile-file-input"
                  className="Manage-input-textarea manage-form-space-adit-input"
                  type="file"
                  required
                  onChange={(e) => {
                    spaceImg(e, "profile", "profileUrl", "profileDeleteFlag");
                  }}
                />
                {spaceInfo.profileUrl ? (
                  <div className="space-img">
                    <img className="uploaded-img" src={spaceInfo?.profileUrl} />
                    <img
                      className="space-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) =>
                        deleteImage(
                          "profile",
                          "profileUrl",
                          "profileDeleteFlag "
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">배경 이미지*</span>
              <div className="space-adit-input-file-container">
                <label htmlFor="back-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="back-file-input"
                  className="Manage-input-textarea manage-form-space-adit-input"
                  type="file"
                  required
                  onChange={(e) => {
                    spaceImg(
                      e,
                      "background",
                      "backgroundUrl",
                      "backgroundDeleteFlag"
                    );
                  }}
                />
                {spaceInfo.backgroundUrl ? (
                  <div className="space-img">
                    <img
                      className="uploaded-img"
                      src={spaceInfo?.backgroundUrl}
                    />
                    <img
                      className="space-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) =>
                        deleteImage(
                          "background",
                          "backgroundUrl",
                          "backgroundDeleteFlag"
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit manage-flex-start">
              <span className="Manage-input-title">공간 소개글*</span>
              <textarea
                placeholder="공간 소개글을 입력하세요 (띄어쓰기 포함 200자 이내 작성)"
                maxLength="200"
                value={spaceInfo.intro}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    intro: e.target.value,
                  }));
                }}
              ></textarea>
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit manage-flex-start">
              <span className="Manage-input-title">운영시간*</span>
              <textarea
                placeholder="운영시간을 입력하세요"
                value={spaceInfo.businessHours}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    businessHours: e.target.value,
                  }));
                }}
              ></textarea>
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">주소*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input space-adit-search-aditress"
                type="text"
                placeholder="주소를 입력하세요"
                required
                value={spaceInfo.address}
                onClick={execDaumPostcode}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    address: e.target.value,
                  }));
                }}
              />
            </div>
            <div className="Manage-input-container Manage-input-container-space-add">
              <span className="Manage-input-title">상세주소</span>
              <input
                className="Manage-input-textarea manage-form-space-add-input"
                type="text"
                placeholder="상세주소를 입력하세요"
                value={spaceInfo.addressDetail}
                onChange={(e) => {
                  setSpaceInfo({
                    ...spaceInfo,
                    addressDetail: e.target.value,
                  });
                }}
              />
            </div>
            {spaceInfo.lat && spaceInfo.lon && (
              <div
                className="Manage-input-container Manage-input-container-space-add"
                style={{ alignItems: "start" }}
              >
                <span className="Manage-input-title">좌표*</span>
                <div>
                  <Map
                    center={{
                      lat: spaceInfo.lat,
                      lng: spaceInfo.lon,
                    }}
                    style={{
                      width: "366px",
                      height: "366px",
                      borderRadius: "4px",
                    }}
                    level={2}
                    maxLevel={3}
                  >
                    <MapMarker
                      position={{
                        lat: spaceInfo.lat,
                        lng: spaceInfo.lon,
                      }}
                      draggable={true}
                      onDragEnd={(e) => {
                        const lat = e.getPosition().getLat();
                        const lon = e.getPosition().getLng();
                        setSpaceInfo({
                          ...spaceInfo,
                          lat,
                          lon,
                        });
                      }}
                    />
                  </Map>
                  <div className="map-position-info">
                    <div>위도 (y좌표) : {spaceInfo.lat}</div>
                    <div>경도 (x좌표) : {spaceInfo.lon}</div>
                  </div>
                </div>
              </div>
            )}
            <div className="Manage-input-container Manage-input-container-space-adit">
              <span className="Manage-input-title">연락처*</span>
              <input
                className="Manage-input-textarea manage-form-space-adit-input"
                type="tel"
                placeholder="연락처를 입력하세요"
                required
                value={spaceInfo.tell}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    tell: e.target.value,
                  }));
                }}
              />
            </div>
          </div>
          <div>
            <span className="space-adit-title">상세설명</span>
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">대표 이미지</span>
              <div className="space-adit-input-file-container">
                <label htmlFor="img-file-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="img-file-input"
                  className="Manage-input-textarea manage-form-space-adit-input"
                  type="file"
                  required
                  onChange={(e) => {
                    spaceImg(e, "image", "imageUrl", "imageDeleteFlag");
                  }}
                />
                {spaceInfo.imageUrl ? (
                  <div className="space-img">
                    <img className="uploaded-img" src={spaceInfo?.imageUrl} />
                    <img
                      className="space-img-cancel cursorPointer"
                      src="\img\image-cancel.svg"
                      onClick={(e) =>
                        deleteImage("image", "imageUrl", "imageDeleteFlag")
                      }
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className="Manage-input-container manage-flex-start">
              <span className="Manage-input-title">상세 이미지</span>
              <div className="space-adit-input-file-container">
                <label htmlFor="files-input">
                  <img src="\img\file-upload-plus.svg" />
                  <span>파일 등록</span>
                </label>
                <input
                  id="files-input"
                  className="Manage-input-textarea manage-form-space-adit-input"
                  type="file"
                  required
                  onChange={(e) => {
                    spaceImgs(e);
                  }}
                />
                {spaceInfo.spaceFiles &&
                  spaceInfo.spaceFiles.map((item, index) => {
                    return (
                      <div className="space-img uploaded-imgs" key={index}>
                        <img className="uploaded-img" src={item.imageUrl} />
                        <img
                          className="space-img-cancel cursorPointer"
                          src="\img\image-cancel.svg"
                          onClick={(e) => {
                            if (item.id) {
                              setDelId((delId) => [...delId, item.id]);
                            }
                            deleteImages(item.id, index);
                          }}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
            <div className="Manage-input-container Manage-input-container-space-adit manage-flex-start">
              <span className="Manage-input-title">상세설명</span>
              <textarea
                placeholder="공간 상세설명을 입력하세요 (띄어쓰기 포함 1000자 이내 작성)"
                maxLength="1000"
                value={spaceInfo.detail}
                onChange={(e) => {
                  setSpaceInfo((spaceInfo) => ({
                    ...spaceInfo,
                    detail: e.target.value,
                  }));
                }}
              ></textarea>
            </div>
          </div>
          <div className="Manage-form-save manage-form-save-space-adit">
            <button className="cursorPointer" onClick={spaceAdd}>
              저장하기
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageSpaceAdit;
